/* Clean Bins 360 — theme.js */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- Smooth scroll (Lenis) — professional eased scrolling ----
  if (!reduceMotion && typeof Lenis !== 'undefined') {
    var lenis = new Lenis({ duration: 1.1, easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); }, smoothWheel: true });
    function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
    // keep in-page anchor links working with smooth scroll
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href');
        if (id.length > 1) {
          var target = document.querySelector(id);
          if (target) { e.preventDefault(); lenis.scrollTo(target, { offset: -80 }); }
        }
      });
    });
  }

  // ---- Carousels (services, reviews, generic) ----
  function step(track) { return Math.max(track.clientWidth * 0.8, 240); }
  document.querySelectorAll('[data-carousel]').forEach(function (c) {
    var track = c.querySelector('.carousel__track');
    if (!track) return;
    var prev = c.querySelector('.carousel__btn--prev');
    var next = c.querySelector('.carousel__btn--next');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(track), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(track), behavior: 'smooth' }); });
  });

  // ---- Hero auto-rotate ----
  document.querySelectorAll('[data-hero]').forEach(function (h) {
    var track = h.querySelector('.carousel__track');
    var slides = h.querySelectorAll('.carousel__slide');
    if (!track || slides.length < 2) return;
    var i = 0;
    var timer = setInterval(rotate, 6000);
    function rotate() {
      i = (i + 1) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    h.addEventListener('mouseenter', function () { clearInterval(timer); });
    h.addEventListener('mouseleave', function () { timer = setInterval(rotate, 6000); });
  });

  // ---- Cookie consent ----
  (function () {
    var banner = document.getElementById('cookie-banner');
    if (!banner) return;
    var KEY = 'cb360_cookie_consent';
    var stored = null;
    try { stored = localStorage.getItem(KEY); } catch (e) {}
    if (!stored) {
      banner.hidden = false;
      requestAnimationFrame(function () { banner.classList.add('is-visible'); });
    }
    banner.querySelectorAll('[data-cookie]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var choice = btn.getAttribute('data-cookie');
        try { localStorage.setItem(KEY, choice); } catch (e) {}
        banner.classList.remove('is-visible');
        setTimeout(function () { banner.hidden = true; }, 300);
        // GA4 Consent Mode hook (fires once GA4 is added)
        if (typeof gtag === 'function') {
          gtag('consent', 'update', {
            ad_storage: choice === 'accept' ? 'granted' : 'denied',
            analytics_storage: choice === 'accept' ? 'granted' : 'denied'
          });
        }
      });
    });
  })();

  // ---- Mobile nav toggle ----
  var navToggle = document.querySelector('.nav-toggle');
  var mobileNav = document.querySelector('.mobile-nav');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // ---- Scroll reveal (Intersection Observer + CSS, progressive enhancement) ----
  if (!reduceMotion && 'IntersectionObserver' in window) {
    var selector = '.benefit, .card, .img-text__media, .img-text__body, .section .container > .text-center, .list-col';
    var els = Array.prototype.slice.call(document.querySelectorAll(selector));

    els.forEach(function (el) {
      // images settle in with a subtle scale; everything else rises
      if (el.classList.contains('img-text__media')) {
        el.classList.add('reveal', 'reveal--zoom');
      } else {
        el.classList.add('reveal');
      }
      // stagger siblings within the same parent for a cascading grid/group effect
      var sibs = Array.prototype.filter.call(el.parentElement.children, function (c) {
        return c.classList && c.classList.contains('reveal');
      });
      var idx = sibs.indexOf(el);
      if (idx > 0) el.style.transitionDelay = Math.min(idx * 80, 360) + 'ms';
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { io.observe(el); });
  }
})();
